import { CalcEmploymentController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Shows / edits the relevant employment relation:
 * Employer, if the current user is worker
 * Worker, if the current user is employer or potentially both in some future admin / pro scenarios.
 * @example
 * ```html
 * <salaxy-calc-employment model="$ctrl.currentCalc"></salaxy-calc-employment>
 * ```
 */
export class CalcEmployment extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */

  public bindings = {
    /** The calculation that is being edited  */
    model: "<",

    /**
     * If true, will also update the calculation rows from employment relation when the employment
     * relation is selected. By default, does not update the rows.
     */
    updateRows: "<",
  };

  /** Uses the CalcEmploymentController */
  public controller = CalcEmploymentController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/calc/2022/CalcEmployment.html";
}
